// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Legacy redirect route for /parts.
 * Redirects to the unified /items page with bulk type filter.
 */
import { ItemsSearchParams } from '@/items/api/types';
import { createFileRoute, redirect } from '@tanstack/react-router';

const REDIRECT_SEARCH: ItemsSearchParams = {
  type: 'bulk',
};

export const Route = createFileRoute('/_app/parts/')({
  beforeLoad: () => {
    throw redirect({
      to: '/catalog/items',
      search: REDIRECT_SEARCH,
    });
  },
});
